import sendRequest from '../../client/sendRequest';

export const uploadImageToCloudinaryWithProgress = async (
  file,
  onProgress,
  folder = 'temp',
  progressRange = [0, 100],
) => {
  if (!file) {
    throw new Error('No file provided');
  }

  if (!file.type?.startsWith('image/')) {
    throw new Error('Only image uploads are allowed');
  }
  // 1. Get signature from backend
  let signData;

  try {
    signData = await sendRequest('/api/upload/sign', 'POST', { folder });
  } catch (err) {
    throw new Error(err.message || 'Failed to get upload signature');
  }

  const {
    timestamp,
    signature,
    apiKey,
    cloudName,
    folder: signedFolder,
  } = signData;

  return new Promise((resolve, reject) => {
    const url = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;

    // 2. Build form data
    const formData = new FormData();
    formData.append('file', file);

    // signed params
    formData.append('api_key', apiKey);
    formData.append('timestamp', timestamp);
    formData.append('signature', signature);
    formData.append('folder', signedFolder);

    // 3. Upload with progress
    const xhr = new XMLHttpRequest();

    xhr.timeout = 30000;

    xhr.ontimeout = () => {
      reject(new Error('Upload timed out'));
    };

    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable && onProgress) {
        const rawProgress = event.loaded / event.total;

        const percent =
          progressRange[0] +
          rawProgress * (progressRange[1] - progressRange[0]);

        onProgress(Math.round(percent));
      }
    });

    xhr.onerror = () => {
      reject(new Error('Network error during upload'));
    };

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let data;

          try {
            data = JSON.parse(xhr.responseText);
          } catch {
            return reject(new Error('Invalid response from Cloudinary'));
          }

          if (onProgress) {
            onProgress(progressRange[1]);
          }

          resolve({
            url: data.secure_url,
            publicId: data.public_id,
          });
        } else {
          try {
            const errData = JSON.parse(xhr.responseText);
            reject(new Error(errData.error?.message || 'Upload failed'));
          } catch {
            reject(new Error('Upload failed'));
          }
        }
      }
    };

    xhr.open('POST', url);
    xhr.send(formData);
  });
};
